/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_item = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbLeadTime_item" | "PdpSharedBlurbReturns_item" | "PdpSharedBlurbShipping_item" | "PdpSharedBlurbUrgency_item" | "PdpSharedBlurbSupportNumber_item" | "PdpSharedBlurbPcs_item">;
    readonly " $refType": "PdpRespSidebarBlurbs_item";
};
export type PdpRespSidebarBlurbs_item$data = PdpRespSidebarBlurbs_item;
export type PdpRespSidebarBlurbs_item$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbLeadTime_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbReturns_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbUrgency_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbSupportNumber_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbPcs_item",
      "args": null
    }
  ]
};
(node as any).hash = '41946536a5659a281d6e8c504cc62f31';
export default node;
